/* eslint-disable no-unused-vars */
import React, { useContext, useState, useRef, useMemo } from 'react'
import { Button, message, Select, Input } from 'antd'
import {
  getApiTargetInfo,
  getEnvConfig,
  ExportComponent,
  UnitSelection,
} from 'core'
import { connect } from 'react-redux'
import R from 'ramda'
import MisoVerificationHistoryDialog from './MisoVerificationHistoricalDialog'
import { CriteriaRow, Title, Content, FullHeightSizer } from 'core/screen-util'
import {
  rowHeaderRender,
  exportDataComponent,
  hasAccesPermits,
} from 'core/utils'
import { UnitSelectionContext, SpinContext, ErrorContext } from 'context'
import {
  getUtilityNameMap,
  getUnitNameMap,
  getUtilityUnitsMap,
  getUnits,
  getCauseCodeMap,
  isUnitLoading,
  getAmlificationCode,
  getFailCode,
  getPermitActions,
  isAdminType,
} from 'core/selectors'
import { Label } from '../core/screen-util'

import moment from 'moment'

import {
  MisoVerificationTestHeaders,
  HeaderRowHeightVerification,
} from './Utils'
import { Grid, virtualizedGridRenderer } from '@integec/grid-tools'
import { getMisoVerificationTest } from 'api/pgads'

const HistoricalNetCapVerif = props => {
  const { unitNameMap, utilityNameMap, apiTargetInfo } = props
  const curYear = parseInt(moment().format('YYYY'))

  const { selectedUnits, setVisibleUnitSelection } = useContext(
    UnitSelectionContext
  )
  const { setError } = useContext(ErrorContext)
  const { spinning, setSpinning } = useContext(SpinContext)

  const [year, setYear] = useState(curYear - 1)
  // const [season, setSeason] = useState('S')

  const [data, setData] = useState([])
  const [fuzzyFilter, setFuzzyFilter] = useState('')
  const [selected, setSelected] = useState({})
  const [showEditDialog, setShowdialogData] = useState(false)

  const onCriteriaChnage = _ => setData([])

  const onRetrieve = _ => {
    if (selectedUnits.length <= 0) {
      message.warn('Please,select Unit(s)')
      setVisibleUnitSelection(true)
      return
    }
    const cr = { unitId: selectedUnits.map(u => u.unitId), year }
    setSpinning(true)
    getMisoVerificationTest(apiTargetInfo)(cr).fork(setError, data => {
      setSpinning(false)
      setData(data)
    })
  }

  const GridRef = useRef()

  const headerWithFormatter = useMemo(
    _ =>
      MisoVerificationTestHeaders.map(h =>
        h.ident === 'utility'
          ? {
              ...h,
              // ...toSelectionColProps(utilityNameMap),
              dataFormatter: ({ value }) => utilityNameMap[value] || value,
              sortIndexGetter: ({ rowData }) =>
                utilityNameMap[rowData.utility] || rowData.utility,
            }
          : h.ident === 'unitId'
          ? {
              ...h,
              // dataGetter: generateDataGetter,
              dataFormatter: ({ value }) => unitNameMap[value] || value,
              sortIndexGetter: ({ rowData }) =>
                unitNameMap[rowData.unitId] || rowData.unitId,
            }
          : { ...h, width: h.width || 150 }
      ),
    [unitNameMap, utilityNameMap]
  )
  const title = 'Historical Net Cap Verification'
  const [visible, setVisible] = useState(false)
  return (
    <React.Fragment>
      <UnitSelection setData={_ => setData([])} />
      <CriteriaRow>
        <Title>{title}</Title>
        <Label style={{ marginLeft: 50 }}>Year : </Label>
        <Select value={year} onChange={setYear} style={{ marginLeft: 10 }}>
          {R.range(curYear - 11, curYear)
            .reverse()
            .map(y => (
              <Select.Option key={y} value={y}>
                {y}
              </Select.Option>
            ))}
        </Select>
        {/* <Label>Season : </Label>
        <Select value={season} onChange={setSeason}>
          <Select.Option key="S" value="S">
            Summer
          </Select.Option>
          <Select.Option key="W" value="W">
            Winter
          </Select.Option>
        </Select> */}

        <Button
          loading={spinning}
          onClick={onRetrieve}
          style={{ marginLeft: '10px' }}
          type="primary"
          icon="database"
        >
          Retrieve
        </Button>
        <Button
          loading={spinning}
          onClick={_ => setVisible(true)}
          style={{ marginLeft: '10px' }}
          type="primary"
          icon="database"
          disabled={Object.keys(selected || {}).length <= 0}
        >
          View Record
        </Button>
        <div style={{ flex: '1 1 0px' }} />
        <Input.Search
          placeholder="Filter"
          value={fuzzyFilter}
          style={{
            marginLeft: '10px',
            marginRight: '10px',
            flex: '0 0 200px',
          }}
          onChange={e => setFuzzyFilter(e.target.value)}
        />
        {/* <ExportComponent
          getData={_ => exportDataComponent(GridRef, data, fuzzyFilter)}
          data={data}
          headers={(MisoVerificationTestHeaders || []).map(d => ({
            ...d,
            rowHeaderBackgroundColor: '#eee',
          }))}
          fileName={title}
          btnStyle={{ marginRight: '10px' }}
          disabled={data.length <= 0}
        /> */}
      </CriteriaRow>
      <FullHeightSizer heightOffset={250}>
        {({ height, width }) => (
          <Content style={{ height: height - 20 }}>
            <Grid
              ref={GridRef}
              // editMode="cell"
              data={data || []}
              headers={headerWithFormatter}
              altBy={o => o.unitId}
              altBgColor="#ebebeb"
              render={virtualizedGridRenderer({
                autoFixColByKey: true,
                rowHeaderRender,
                height: height - 40,
                width: width - 50,
                headerRowHeight: HeaderRowHeightVerification,
              })}
              fuzzyFilter={fuzzyFilter}
              onSelectionChange={({ selectedRows }) => {
                setSelected(selectedRows[0])
              }}
              initialSortOptions={MisoVerificationTestHeaders}
              sortOptions={MisoVerificationTestHeaders}
              sortEnabled
              isEditable={false}
              selectionType="row"
              selectionMode="single"
            />
          </Content>
        )}
      </FullHeightSizer>
      <MisoVerificationHistoryDialog
        data={{ ...selected }}
        unitNameMap={props.unitNameMap}
        utilityNameMap={utilityNameMap}
        visible={visible}
        setVisible={_ => setVisible(false)}
      />
    </React.Fragment>
  )
}

const getXeforlData = (selected = {}, exfordDataList = []) => {
  const found = exfordDataList.find(
    x =>
      x.unitId === selected.unitId &&
      x.year === selected.year &&
      x.period === selected.period &&
      x.testIdx === selected.testIdx &&
      x.standard === selected.standard
  )

  return found
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
  utilityNameMap: getUtilityNameMap(state),
  unitNameMap: getUnitNameMap(state),
  utilityUnitMap: getUtilityUnitsMap(state),
  units: getUnits(state),
  actionPermits: getPermitActions(state),
  envConfig: getEnvConfig(state),
  isAdminType: isAdminType(state),
})

export default connect(mapStateToProps)(HistoricalNetCapVerif)
